import { render, staticRenderFns } from "./ArticleTile.vue?vue&type=template&id=756d661c&scoped=true"
import script from "./ArticleTile.vue?vue&type=script&lang=ts"
export * from "./ArticleTile.vue?vue&type=script&lang=ts"
import style0 from "./ArticleTile.vue?vue&type=style&index=0&id=756d661c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756d661c",
  null
  
)

export default component.exports